import { AbstractEntityMapper } from '@pf/shared-services';
import {
    PackLineCreate,
    PackLineDto,
    PackLineRead,
    PackLineSearchParams,
} from '../../entities/pack-line.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { PackLineMetadataMap } from './pack-line.mapping-profile';

@Injectable()
export class PackLineMapper extends AbstractEntityMapper<
    PackLineRead,
    PackLineCreate,
    PackLineDto,
    PackLineSearchParams
> {
    constructor() {
        super(PackLineDto, PlatformWmsMapper, PackLineMetadataMap.symbols);
    }
}
